
<template>
  <main>
    <nav-bar type="full"></nav-bar>
    <div :class="['content', { 'show-guide': showGuide }]">
      <side-bar @collapse="handleSideBarCollapse"/>
      <div class="dashboard" :style="{paddingLeft: isCollapse ? '.66rem' : '2.1rem'}">
        <holiday-alert v-if="showHoliday"></holiday-alert>
        <certification-alert v-if="!showHoliday && $route.path.split('/')[1] !== 'workorder'"></certification-alert>
        <national-day-alert v-if="showNationalday"></national-day-alert>
        <transition name="fade" mode="out-in">
          <router-view name="dashboard"></router-view>
        </transition>
        <c-footer/>
      </div>
    </div>
    <guide v-if="showGuide" @close="showGuide = false"/>
    <icons></icons>
    <service-icons></service-icons>
    <input id="copyUrl" class="copyUrl" type="text" name="copyUrl">
  </main>
</template>

<script>
import appApi from 'api/my-app'
import NavBar from 'NavBar/Main'
import SideBar from 'SideBar/Main'
import CertificationAlert from 'CertificationAlert/Main'
import HolidayAlert from 'HolidayAlert/Main'
import NationalDayAlert from 'HolidayAlert/NationalDay'
import Guide from 'Guide'
import Icons from 'Icons'
import ServiceIcons from 'ServiceIcons'
import CFooter from './Footer/Footer'
import { mapActions } from 'vuex'

export default {
  name: 'MainContent',
  components: {
    NavBar,
    SideBar,
    CertificationAlert,
    HolidayAlert,
    Icons,
    ServiceIcons,
    Guide,
    CFooter,
    NationalDayAlert
  },
  data() {
    return {
      showGuide: this.$route.path.split('/')[1] === 'services' && localStorage.getItem('__hw') === '1',
      isCollapse: this.$route.path.split('/')[1] !== 'services',
      showHoliday: new Date().getTime() >= new Date('2020/09/22 00:00').getTime() && new Date().getTime() < new Date('2020/11/16 00:00').getTime() && this.$route.path.split('/')[1] !== 'workorder',
      showNationalday: new Date().getTime() >= new Date('2020/10/01 00:00').getTime() && new Date().getTime() < new Date('2020/10/08 23:59').getTime() && this.$route.path.split('/')[1] === 'workorder',
    }
  },
  mounted() {
    // 获取默认应用ID
    appApi.getDefaultApp().then(defalutData => {
      if (defalutData.code === 0 || defalutData.code === '0') {
        if (defalutData.data) {
          // 如果未设置默认应用，跳转应用列表设置
          this.setAppId(defalutData.data.appId || '')
          this.setAppName(defalutData.data.appName || '')
        } else {
          // 限制未选择默认应用的校验范围，防止每个入口链接都校验体验不好
          if (this.$route.path.split('/')[1] !== 'services') {
            return
          }
          // 有应用但未设置默认应用，此用户为老用户需要弹出更新引导，设置默认应用后__hw=1，引导结束删除标志
          localStorage.setItem('__hw', '0');
          this.$message.warning('控制台新版本更新，请点击应用名称进入新版应用管理面板')
          this.$router.push({ path: '/app/myapp' })
        }
      } else if (defalutData.code === -1 || defalutData.code === '-1') {
        // 如果没有应用跳转创建应用
        // this.$message.warning('请先创建一个应用')
        // this.$router.push({ path: '/app/create', query: { redirect: this.$route.path } })
      } else {
        this.$message.error('获取当前选择应用失败:' + data.desc)
      }
    }).catch(errMsg => {
      this.$message.error('获取当前选择应用失败:' + errMsg)
    })
  },
  methods: {
    ...mapActions([
      'setAppId',
      'setAppName'
    ]),
    handleSideBarCollapse(value) {
      this.isCollapse = value
    }
  },
  watch: {
    '$route' (to, from) {
      this.showHoliday = new Date().getTime() >= new Date('2020/09/22 00:00').getTime() && new Date().getTime() < new Date('2020/11/16 00:00').getTime() && this.$route.path.split('/')[1] !== 'workorder',
      // this.showHoliday = new Date().getTime() >= new Date('2020/09/22 00:00').getTime() && new Date().getTime() < new Date('2020/11/16 00:00').getTime() && this.$route.path.split('/')[1] === 'workorder'
      this.showNationalday = new Date().getTime() >= new Date('2020/10/01 00:00').getTime() && new Date().getTime() < new Date('2020/10/08 23:59').getTime() && this.$route.path.split('/')[1] === 'workorder'
      this.showGuide = this.$route.path.split('/')[1] === 'services' && localStorage.getItem('__hw') === '1'
      // 鼠标停在侧边栏的同时切换页面只有可能发生在应用列表、应用创建编辑及服务卡片页面
      if (this.$route.path.split('/')[1] !== 'app') {
        this.isCollapse = this.$route.path.split('/')[1] !== 'services'
      }
      if (to.path === '/app/create') {
        this.isCollapse = true
      }
    }
  },
}
</script>

<style lang="stylus">
@import '~styl/mixins'
svg-icons()
main
  height: 100%
.content
  position absolute
  left 0
  right 0
  top .6rem
  bottom 0
  &.show-guide
    overflow hidden
.dashboard
  height 100%
  min-width 13.5rem
  padding-left 2.1rem
  border-left 1px #e4e4e4 solid
  z-index auto
  overflow-y auto
  // transition padding-left .3s ease-in-out
.clearfix 
  zoom: 1
  &:after 
    content: " "
    display: block
    clear: both
    height: 0
.page .el-tabs__active-bar,.page .el-table::after,.page .el-table::before
  z-index:0
.copyUrl
  position absolute;
  top 0;
  opacity 0;
  z-index 0;
</style>



// WEBPACK FOOTER //
// app/components/MainContent.vue